/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAccountingCurrency } from 'app/shared/model/accounting-currency.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IAccountingTransaction } from 'app/shared/model/accounting-transaction.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IAccountingExpenseLedger {
  id?: string;
  ledgerNo?: string;
  amount?: number;
  remarks?: number | null;
  currencyRate?: number;
  settled?: boolean | null;
  pendingAmount?: number | null;
  transactedById?: string | null;
  transactedByType?: keyof typeof AddedByType | null;
  closed?: boolean | null;
  entityId?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  baseCurrency?: IAccountingCurrency | null;
  category?: IClinicalDictionary | null;
  entityType?: IClinicalDictionary | null;
  accountTransaction?: IAccountingTransaction | null;
}

export const defaultValue: Readonly<IAccountingExpenseLedger> = {
  settled: false,
  closed: false,
  active: false,
};
